<template>
  <div class="vipService">
    <div :class="`${$root.$data.isApp || $root.$data.miniprogram ? 'isHidden' : ''}`">
      <common-title titleName="服务介绍" :zIndex="1000"></common-title>
      <div class="empty"></div>
    </div>

    <div :class="`box ${$root.$data.isApp || $root.$data.miniprogram ? '' : 'boxMini'}`" >
      <div class="sidebar">
        <ul>
          <li :id="`title-${index}`" v-for="(section, index) in sections" :key="index">
            <div class="title" v-if="index === 0">动能助力</div>
            <div class="h36" v-if="index === prepareIndex"></div>
            <div class="border" v-if="index === prepareIndex"></div>
            <div class="title1" v-if="index === prepareIndex">备考保障</div>
            <div class="subTitle" :class="{ active: currentIndex === index }" @click="scrollToSection(index, true)">{{
      section.title }}</div>
          </li>
        </ul>
      </div>
      <div class="content-wrapper" ref="wrapper">
        <div class="content" ref="content">
          <div v-for="(section, index) in sections" :key="index" :ref="'section' + index" class="section">

            <h2 :style="{ 'padding-top': index === 0 ? 36 : 0 }"><img :src="section.icon"><span class="sectionTitle">{{
      section.title }}</span></h2>
            <div class="richHtml" v-html="section.content"></div>
            <div class="36" v-if="index === (sections.length - 1)"></div>
          </div>
        </div>
      </div>
    </div>
     <div class="chat" @click="openChat"></div>
  </div>
</template>

<script>
import BScroll from 'better-scroll';
// eslint-disable-next-line import/no-cycle
import { reqCourseExperience } from '@/api/vipProduct/index';
import wx from 'weixin-js-sdk';

export default {
  data() {
    return {
      sections: [],
      bs: null,
      currentIndex: 0,
    };
  },
  created() {
  },
  mounted() {
    this.$toast.loading({
      duration: 0,
      message: '加载中...',
      forbidClick: true,
    });
    reqCourseExperience(Number(this.$route.query.id)).then((res) => {
      const { data } = res;
      const { benefitsKineticEnergyVOList, benefitsExamAssuranceVOList } = data.vipCourseExperienceBenefitsRespVO;
      const temp = [...benefitsKineticEnergyVOList, ...benefitsExamAssuranceVOList];
      this.sections = temp;
      this.prepareIndex = benefitsKineticEnergyVOList.length;
      this.$nextTick(() => {
        const timer1 = setTimeout(() => {
          // 其实我也不想写这个定时器的，这相当于又嵌套了一层$nextTick，但是不这么写会失败
          if (timer1) {
            clearTimeout(timer1);
            this.initScroll();
          }
        }, 200);
      });
    });
  },
  methods: {
    initScroll() {
      if (this.bs) {
        this.bs.destroy();
      }
      this.bs = new BScroll(this.$refs.wrapper, {
        scrollY: true,
        click: true,
        probeType: 3, // 开启 probe 以监听滚动事件
        bounce: false,
      });
      this.scrollToSection(Number(this.$route.query.active));
      document.getElementById(`title-${this.$route.query.active}`).scrollIntoView({ behavior: 'smooth' });
      this.bs.on('scroll', this.onScroll);
    },
    scrollToSection(index, flag) {
      const targetElement = this.$refs[`section${index}`][0];
      this.bs.scrollToElement(targetElement, 800);
      if (flag) {
        this.currentIndex = index;
      } else {
        const timer2 = setTimeout(() => {
          // 其实我也不想写这个定时器的，这相当于又嵌套了一层$nextTick，但是不这么写会失败
          if (timer2) {
            clearTimeout(timer2);
            this.currentIndex = index; // 更新当前索引
            this.$toast.clear();
          }
        }, 1000);
      }
    },
    onScroll() {
      const sections = this.sections.map((section, index) => this.$refs[`section${index}`][0]);
      const scrollTop = -this.bs.y;

      for (let i = 0; i < sections.length; i++) {
        const sectionTop = sections[i].offsetTop;
        const sectionHeight = sections[i].offsetHeight;
        if (scrollTop >= sectionTop && scrollTop < sectionTop + sectionHeight) {
          this.currentIndex = i;
          break;
        }
      }
    },
     openChat() {
      let url =
        'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=665818671c64a1000119f4b2';
      if (this.$root.$data.isApp) {
        url =
          'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=66696197735feb0001e5a925';
        this.$sendToApp(
          'openNewWebView',
          {
            url,
          },
          false,
        );
        return;
      }
      if (this.$root.miniprogram) {
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(url)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
        return;
      }
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.vipService {
  height: 100vh;
}

.empty {
  width: 100%;
  height: 100px;
}

.isHidden {
  display: none;
}

.box {
  display: flex;
  height: 100vh;
}
.boxMini {
  height: calc(100vh - 100px);
}

.sidebar {
  width: 188px;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}

.sidebar ul {
  padding: 0;
  list-style: none;
}

.sidebar li {
  background: #fff;
  cursor: pointer;
}

.sidebar .title {
  padding: 54px 0 35px 36px;
  color: #333;
  font-weight: 500;
  font-size: 29px;
  font-style: normal;
  text-align: center;
  text-align: left;
}

.sidebar .title1 {
  padding: 71px 0 35px 36px;
  color: #333;
  font-weight: 500;
  font-size: 29px;
  font-style: normal;
  text-align: center;
  text-align: left;
}

.h36 {
  width: 100%;
  height: 36px;
}

.border {
  width: 152px;
  height: 2px;
  margin-left: 18px;
  border: 1px solid #DADADA;
}

.sidebar .subTitle {
  position: relative;
  height: 108px;
  padding-left: 36px;
  color: #999;
  font-weight: 400;
  font-size: 25px;
  font-style: normal;
  line-height: 108px;
  text-align: left;
}

.sidebar .subTitle.active {
  color: #FF7F41;
  background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/service_bg.png');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 188px 89px;
}

.sidebar .subTitle.active::before {
  position: absolute;
  top: 45px;
  left: 0;
  display: block;
  width: 5px;
  height: 25px;
  background: #FF7F41;
  content: '';
}

.content-wrapper {
  flex: 1;
  padding: 36px;
  overflow: hidden;
}

.content {
  margin-top: 36px;
}

.section {
  box-sizing: border-box;
  margin-bottom: 58px;

  &:first-child {
    padding-top: 36px
  }

  &:last-child {
    padding-bottom: 36px
  }
}

.section h2 {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.section h2 img {
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-right: 7px;
}

.section h2 .sectionTitle {
  color: #333;
  font-weight: 500;
  font-size: 25px;
  font-style: normal;
  line-height: 36px;
  text-align: left;
}

.richHtml {
  ::v-deep p {
    min-height: 40px;
    color: #333;
    font-weight: 400;
    font-size: 22px;
    font-style: normal;
    line-height: 33px;
    text-align: left;
  }

  ::v-deep img {
    display: inline-block;
    max-width: 100% !important;
  }

}
    .chat {
    position: fixed;
    right: 0;
    bottom: 200px;
    z-index: 10;
    width: 127px;
    height: 105px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/chat-icon1.png');
    background-size: 100%;
  }
</style>
